import React from 'react';

export default (props: any) => {
  return (
    <div className="custom-tooltip" style={{
      backgroundColor: '#fff',
      padding: '5px',
      border: '1px solid #999',
      maxWidth: '400px',
      whiteSpace: 'pre-wrap'
    }}>
      {props.value}
    </div>
  );
};